import React from 'react';
import { Image } from 'semantic-ui-react';
import './Login.css';

export default function Splash() {
  return (
    <div className="login">
      <div className="login-form">
        <Image id="app-logo" className="top-img" src="/logo-app.png" />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Splash.js